import React from 'react'

const SalesGraph = () => {
  return (
    <div>SalesGraph</div>
  )
}

export default SalesGraph